module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-douwe-egberts-00.1.dddf0168.jpg";